import { useState } from 'react';
import { textToImage, textToImageStatus } from "@/api/apiMethods.js";
import { imgToVideo, imgToVideoStatus } from "@/api/apiMethods.js";

function Ai() {
    // 文生图功能区
    const [description, setDescription] = useState('');  // 用户输入文生图描述
    const [videoDescription, setVideoDescription] = useState('');  // 用户输入视频描述
    const [modelId, setModelId] = useState('ae-sdxl-v1');
    const [negativePrompt, setNegativePrompt] = useState('');
    const [imgWidth, setImgWidth] = useState(512);
    const [imgHeight, setImgHeight] = useState(512);
    const [enhancePrompt, setEnhancePrompt] = useState('yes');
    const [enhanceStyle, setEnhanceStyle] = useState('cinematic-diva');
    const [imgSeed, setImgSeed] = useState(-1);
    const [guidanceScale, setGuidanceScale] = useState(7);
    const [tomesd, setTomesd] = useState('yes');
    const [useKarrasSigmas, setUseKarrasSigmas] = useState('yes');
    const [ImgVae, setImgVae] = useState('');
    const [loraStrength, setLoraStrength] = useState('');
    const [loraModel, setLoraModel] = useState('');
    const [selfAttention, setSelfAttention] = useState('yes');
    const [clipSkip, setClipSkip] = useState(2);
    const [highresFix, setHighresFix] = useState('no');

    const [imageUrl, setImageUrl] = useState('');         // 生成的图片
    const [videoUrl, setVideoUrl] = useState('');
    const [message, setMessage] = useState('');
    const [vmessage, setvMessage] = useState('');
    const [desc, setdesc] = useState('');
    const [isLoading, setIsLoading] = useState(false);    // 加载状态
    const [radioStates, setRadioStates] = useState({
        EnhancePrompt: 'yes',   // 默认值
        tomesd: 'yes',
        useKarrasSigmas: 'yes',
        selfAttention: 'yes',   // 默认值
        highresFix: 'no',
    });

    const handleInputChange = (e) => {
        setDescription(e.target.value);
        setMessage('');
    };
    const handleVideoInputChange = (e) => {
        setVideoDescription(e.target.value);
        setvMessage('');
    };
    const inputFields = [
        {
            label: 'Model ID',
            value: modelId,
            onChange: (e) => setModelId(e.target.value),
            placeholder: 'model_id',
        },
        {
            label: 'Negative Prompt',
            value: negativePrompt,
            onChange: (e) => setNegativePrompt(e.target.value),
            placeholder: 'negative_prompt',
        },
        {
            label: 'Width',
            value: imgWidth,
            onChange: (e) => setImgWidth(e.target.value),
            placeholder: 'width',
            type: 'number',
        },
        {
            label: 'Height',
            value: imgHeight,
            onChange: (e) => setImgHeight(e.target.value),
            placeholder: 'height',
            type: 'number',
        },
        {
            label: 'EnhancePrompt',
            value: enhancePrompt,
            onChange: (e) => setEnhancePrompt(e.target.value),
            type: 'radio',
            options: [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
            ],
        },
        {
            label: 'enhance Style',
            value: enhanceStyle,
            onChange: (e) => setEnhanceStyle(e.target.value),
            placeholder: 'enhanceStyle',
        },
        {
            label: 'Seed',
            value: imgSeed,
            onChange: (e) => setImgSeed(e.target.value),
            placeholder: 'Seed',
            type: 'number',
        },
        {
            label: 'guidance Scale',
            value: guidanceScale,
            onChange: (e) => setGuidanceScale(e.target.value),
            placeholder: 'guidanceScale',
            type: 'number',
        },
        {
            label: 'tomesd',
            value: tomesd,
            onChange: (e) => setTomesd(e.target.value),
            type: 'radio',
            options: [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
            ],
        },
        {
            label: 'useKarrasSigmas',
            value: useKarrasSigmas,
            onChange: (e) => setUseKarrasSigmas(e.target.value),
            type: 'radio',
            options: [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
            ],
        },
        {
            label: 'vae',
            value: ImgVae,
            onChange: (e) => setImgVae(e.target.value),
            placeholder: 'vae',
        },
        {
            label: 'lora Strength',
            value: loraStrength,
            onChange: (e) => setLoraStrength(e.target.value),
            placeholder: 'loraStrength',
        },
        {
            label: 'lora Model',
            value: loraModel,
            onChange: (e) => setLoraModel(e.target.value),
            placeholder: 'loraModel',
        },
        {
            label: 'selfAttention',
            value: selfAttention,
            onChange: (e) => setSelfAttention(e.target.value),
            type: 'radio',
            options: [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
            ],
        },
        {
            label: 'clipSkip',
            value: clipSkip,
            onChange: (e) => setClipSkip(e.target.value),
            placeholder: 'clipSkip',
            type: 'number',
        },
        {
            label: 'highresFix',
            value: highresFix,
            onChange: (e) => setHighresFix(e.target.value),
            type: 'radio',
            options: [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
            ],
        },
    ];

    // 生成图片
    const handleGenerateImage = async () => {
        if (!description) {
            setMessage('The input cannot be empty, please enter a description of the picture');
            return;
        }
        setIsLoading(true);
        try {
            const res = await textToImage({
                model_id: modelId,
                prompt: description,
                negative_prompt: negativePrompt,
                width: imgWidth,
                height: imgHeight,
                enhance_prompt: enhancePrompt,
                enhance_style: enhanceStyle,
                seed: imgSeed,
                guidance_scale: guidanceScale,
                tomesd: tomesd,
                use_karras_sigmas: useKarrasSigmas,
                vae: ImgVae,
                lora_strength: loraStrength,
                lora_model: loraModel,
                self_attention: selfAttention,
                clip_skip: clipSkip,
                highres_fix: highresFix
            });
            setdesc(res);
            const intervalId = setInterval(async () => {
                const resStatus = await textToImageStatus({ fetch_id: res.id });
                if (resStatus.status === 'success') {
                    clearInterval(intervalId);
                    setImageUrl(resStatus.output[0]);
                    setIsLoading(false);
                } else {
                    setMessage(resStatus.msg);
                }

                console.log(res, resStatus);
            }, 5000);
        } catch (error) {
            console.error('Error occurred:', error);
            setIsLoading(false);
        }
    };

    const handleRadioChange = (e, field) => {
        setRadioStates(prevState => ({
            ...prevState,
            [field]: e.target.value,  // 更新 radioStates
        }));

        if (field === 'enhancePrompt') {
            setEnhancePrompt(e.target.value);  // 同时更新 enhancePrompt
        } else if (field === 'selfAttention') {
            setSelfAttention(e.target.value);  // 同时更新 selfAttention
        }
    };


    // 生成视频
    const handleGenerateVideo = async () => {
        if (!videoDescription) {
            setvMessage('The input cannot be empty, please enter a description of the picture');
            return;
        }
        setIsLoading(true);
        try {
            const response = await imgToVideo({
                promptImage: imageUrl,  // 图片的 URL
                promptText: videoDescription,  // 生成视频时的描述文字
                duration: 5  // 视频持续时间
            });
            console.log(response);
            if (response) {
                const videoInter = setInterval(async () => {
                    const videoStatus = await imgToVideoStatus({
                        id: response.id,
                    });
                    console.log(videoStatus, 'videoStatus');
                    if (videoStatus.status === 'SUCCEEDED') {
                        console.log(videoStatus, 'videoStatus');
                        setVideoUrl(videoStatus.output[0]);
                        clearInterval(videoInter);
                        setIsLoading(false);
                    }
                }, 5000);
            }
        } catch (e) {
            console.log(e.message);
        }
    };

    return (
        <div className="bg-black h-screen text-white flex justify-between p-4">
            <div className="flex-1 px-4">
                <div>
                    <h1 className="text-2xl font-bold mb-4">Text to Image Endpoint</h1>
                    <textarea
                        value={description}
                        onChange={handleInputChange}
                        placeholder="Input description to generate image"
                        className="w-full p-2 mb-4 text-black rounded"
                        rows="2"
                        cols="50"
                    ></textarea>
                    <p className='text-red-500'>{message}</p>
                </div>
                {imageUrl && (
                    <div>
                        <h1 className="text-2xl font-bold mb-4">Image to Video Endpoint</h1>
                        <textarea
                            value={videoDescription}
                            onChange={handleVideoInputChange}
                            placeholder="Input description to generate video"
                            className="w-full p-2 mb-4 text-black rounded"
                            rows="2"
                            cols="50"
                        ></textarea>
                        <p className='text-red-500'>{vmessage}</p>
                    </div>
                )}
                <div className='flex'>
                    <div className="border border-white p-4 flex flex-wrap justify-between">
                        {inputFields.map((field, index) => (
                            <div className="flex mb-4 w-[48%]" key={index}>
                                <label htmlFor={field.label} className="w-[71%] flex items-center justify-start">{field.label}</label>
                                {field.type === 'radio' ? (
                                    <div className="flex gap-2 w-[60%]">
                                        {field.options.map(option => (
                                            <label key={option.value} className="flex items-center">
                                                <input
                                                    type="radio"
                                                    name={field.label}
                                                    value={option.value}
                                                    checked={radioStates[field.label] === option.value}
                                                    onChange={(e) => handleRadioChange(e, field.label)}
                                                    className="mr-2"
                                                />
                                                {option.label}
                                            </label>
                                        ))}
                                    </div>
                                ) : (
                                    <input
                                        id={field.label}
                                        type={field.type || 'text'}
                                        value={field.value}
                                        onChange={field.onChange}
                                        placeholder={field.placeholder}
                                        className="input input-bordered w-[80%] text-black"
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    onClick={handleGenerateImage}
                    className="bg-blue-500 px-6 py-2 rounded text-white font-bold mb-4 mt-4"
                    disabled={isLoading}
                >
                    {isLoading ? 'Generating...' : 'Generate image'}
                </button>
                {imageUrl && !isLoading && (
                    <button
                        onClick={handleGenerateVideo}
                        className="bg-blue-500 px-6 py-2 rounded text-white font-bold mb-4 mt-4 ml-3"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Generating...' : 'Generate video'}
                    </button>
                )}
            </div>
            <div className='flex-1 w-[300px] h-[655px] border border-white'>
                <h4 className='text-4xl font-bold mb-4 p-2'>Preview</h4>
                {isLoading && (
                    <div className="flex justify-center mb-4">
                        <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
                    </div>
                )}
                <div className="mb-4 flex items-center justify-between">
                    {imageUrl && !isLoading && (
                        <img
                            src={imageUrl}
                            alt="Generated"
                            className="rounded shadow-lg"
                            style={{ maxWidth: '45%' }}
                        />
                    )}
                    {videoUrl && !isLoading && (
                        <div className="flex-1 ml-3">
                            <video className="w-full" loop autoPlay muted>
                                <source src={videoUrl} type="video/mp4" />
                            </video>
                        </div>
                    )}
                </div>
            </div>
            <div className='flex-1 w-[300px] h-[655px] overflow-auto border border-white ml-3'>
                <h4 className='text-4xl font-bold mb-4 p-2'>result</h4>
                <h4 className='text-4xl font-bold mb-4 p-2'>{ }</h4>
                <div className="bg-black p-4 text-white">
                    <pre>{JSON.stringify({ desc }, null, 2)}</pre>
                </div>
            </div>
        </div>
    );
}

export default Ai;
